import { Model } from '@vuex-orm/core';
import AccountingInfoAPI from '@/api/AccountingInfoAPI';
import { SessionStorageService as ss } from '@/services/SessionStorageService';
import { AccountingInfoOptionFields } from '@/interfaces/AccountingInfoOption';
import i18n from '@/i18n';
import { notification } from 'ant-design-vue';

export default class AccountingInfoOption extends Model {
  public static entity = 'accountingInfo';
  public static apiType = '';
  public static storageKey = '';

  public static fields() {
    return {
      id: this.attr(null),
      code: this.attr(null),
      description: this.attr(null),
    };
  }

  public static async getAll() {
    let res; 
    if (ss.has(this.storageKey)) {
        const data = ss.getAndParse(this.storageKey);
        res = { data, status: 200, statusText: 'OK', headers: {}, config: {} };
    } else {
        try {
            res = await AccountingInfoAPI.getAll(this.apiType);
            const data = res.data;
            ss.stringifyAndSave(this.storageKey, data);
        } catch (e) {
            return Promise.reject(e);
        }
    }
    this.insertOrUpdate({ data: res.data });
    return res;
  }

  public static async createNew(data: AccountingInfoOptionFields) {
    try {
      const res = await AccountingInfoAPI.create(this.apiType, data);
      const newItem = res.data;

      this.insertOrUpdate({ data: newItem });
      
      const list = ss.getAndParse(this.storageKey) || [];
      list.push(newItem);
      ss.stringifyAndSave(this.storageKey, list);
      
      return res;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public static async updateExisting(id: string | number, data: AccountingInfoOptionFields) {
    try {
      const res = await AccountingInfoAPI.update(this.apiType, id, data);
      const updatedItem = res.data;

      this.insertOrUpdate({ data: updatedItem });
      
      const list = ss.getAndParse(this.storageKey) || [];
      const index = list.findIndex((i: any) => String(i.id) === String(id));
      
      if (index !== -1) {
        list[index] = updatedItem;
        ss.stringifyAndSave(this.storageKey, list);
      }
      
      return res;
    } catch (e) {
      return Promise.reject(e);
    }
  }


  public static async deleteExisting(id: string | number) {
    try {
      await AccountingInfoAPI.delete(this.apiType, id);
      await this.delete(id);
      
      const list = ss.getAndParse(this.storageKey) || [];
      const updated = list.filter((i: any) => String(i.id) !== String(id));
      ss.stringifyAndSave(this.storageKey, updated);
      
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public id!: string;
  public code!: string;
  public description!: string;
}